export enum ProjectNotification {
  LearnerLogins,
  ProjectPlan,
  ProgressReport,
}
